import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import { IconButtonStyled } from './magic-svg.styles';

function MagicSvgIconButton({ icon, onClick, tooltip }) {
  return (
    <Tooltip title={tooltip}>
      <IconButtonStyled onClick={onClick}>
        {icon}
      </IconButtonStyled>
    </Tooltip>
  );
}

MagicSvgIconButton.propTypes = {
  icon: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired,
  tooltip: PropTypes.string.isRequired,
};

export default MagicSvgIconButton;
